import {
  Box,
  Button,
  Divider,
  Flexbox,
  Heading,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  shootToast,
  Stack,
  StackRow,
  Textarea,
} from "codekit";

import { useForm, FormProvider, Controller } from "react-hook-form";
import { useState } from "react";

import {
  useCreateSolicupoMutation,
  useLazyGetPendingAuthotizationsQuery,
} from "../../../../libs/redux/slices/Modimpxx/Solicupo/solicupoApiSlice";
import { setModuleURL } from "../../../../libs/redux/slices/authSlice/authSlice";
import { useDispatch } from "react-redux";

/**
 * Componente padre Antiprov Cliente
 * @returns Component
 */
const Solicupo = ({ doInfo, setIsSolicupo }) => {
  const dispatch = useDispatch();
  const methods = useForm({
    mode: "all",
  });

  const cimaModuleAutoriza = "Autoriza";
  const cimaModuleModimpxx = "Modimpxx";
  const AUTIDXXX = "101";
  const CIACRESX = "PENDIENTE";
  const [getPendingAuthotizations] = useLazyGetPendingAuthotizationsQuery();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
  } = methods;

  const [createSolicupo] = useCreateSolicupoMutation();
  const [isCreating, setIsCreating] = useState(false);

  const hasError = Object.keys(errors).length;
  const isFormValid = !hasError;

  //Mostrar mensajes en pantalla
  const showErros = (variant, text) => {
    shootToast({
      variant,
      text,
      duration: 5000,
      autoHide: true,
    });
  };

  //Guardado del formulario
  const onSubmit = async (formData) => {
    //Valido que no tenga autorizaciones pendientes
    const isPending = await handlePendingAuthotizations(formData.DOCNROXX);
    if (isPending) {
      showErros("error", "El Do ya cuenta con Autorizaciones en Estado PENDIENTE, Por favor valida.");
      setIsCreating(false);
      return;
    }
    dispatch(setModuleURL(cimaModuleAutoriza.toLowerCase()));
    const newData = { ...formData };
    setIsCreating(true);
    await createSolicupo(newData)
      .unwrap()
      .then(async (response) => {
        setIsCreating(false);
        close();
      })
      .catch()
      .finally(() => {
        setIsCreating(false);
      });
  };

  const close = () => {
    dispatch(setModuleURL(cimaModuleModimpxx.toLowerCase()));
    setIsSolicupo(false);
  };

  //Funcion para consultar si un DO cuenta con autorizacion pendientes
  const handlePendingAuthotizations = async (DOCNROXX) => {
    setIsCreating(true);
    return await getPendingAuthotizations({ filters: { DOCNROXX } })
      .unwrap()
      .then((response) => {
        const { data } = response;
        return data?.pending;
      })
      .catch();
  };

  return (
    <Modal size="sm" isOpen={true}>
      <ModalHeader>
        <Flexbox justifyContent="between" alignItems="center">
          <Heading variant="heading-6">Solicitar cupo adicional</Heading>
          <Button variant="secondary" icon="close" onlyIcon size="m" onClick={() => close()} />
        </Flexbox>
      </ModalHeader>
      <FormProvider {...methods}>
        <form id="solicupo" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody size="sm">
            <Box mb={8}>
              <Divider text="Datos generales" color="accent-600" />
            </Box>
            <Box mb={8}>
              <Stack gap={3} columns={2}>
                <StackRow>
                  <Label>Id de la operación</Label>
                  <Input
                    {...register("DOCNROXX", { required: true })}
                    value={doInfo.DOCNROXX}
                    isInvalid={errors.DOCNROXX}
                    placeholder="DO"
                    readOnly={true}
                  />
                  <Input style={{ display: "none" }} {...register("AUTIDXXX")} type="hidden" value={AUTIDXXX}></Input>
                  <input {...register("CIACRESX")} type="hidden" value={CIACRESX} />
                </StackRow>
                <StackRow>
                  <Label>Cliente</Label>
                  <Input
                    {...register("CLINOMXX", { required: true })}
                    value={doInfo.CLINOMXX}
                    isInvalid={errors.CLINOMXX}
                    placeholder="Cliente"
                    readOnly={true}
                  />
                  <Input value={doInfo.CLIIDXXX} {...register(`CLIIDXXX`, { required: true })} type="hidden"></Input>
                </StackRow>
              </Stack>
              <Stack gap={3} columns={1}>
                <StackRow>
                  <Label>Valor autorización cupo</Label>
                  <Controller
                    name="AUTVLRXX"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="currency"
                        currencyMode="european"
                        placeholder="Valor autorización cupo"
                        style={{ textAlign: "right" }}
                        value={field.value ?? doInfo.AUTVLRXX}
                        isInvalid={!!errors.AUTVLRXX}
                        onFocus={(e) => {
                          field.onChange(e.target.value);
                        }}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    )}
                  />
                </StackRow>
              </Stack>
            </Box>
            <Stack gap={4}>
              <StackRow>
                <Label>Observaciones</Label>
                <Textarea {...register(`CIACOBSX`)} />
              </StackRow>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Flexbox justifyContent="between" alignItems="center" gap={4}>
              <Button
                type="button"
                variant="secondary"
                size="2l"
                minWidth={200}
                onClick={() => {
                  close();
                }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="primary-bold"
                size="2l"
                minWidth={200}
                isLoading={isCreating}
                disabled={!isFormValid}
              >
                Crear
              </Button>
            </Flexbox>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default Solicupo;
